/* eslint-disable @typescript-eslint/await-thenable, react-hooks/exhaustive-deps */
import { useEffect } from "react"

export function useOnMount(mount?: () => void, unmount?: () => void) {
  useEffect(() => {
    const asyncCB = async () => {
      if (mount) await mount()
    }
    asyncCB()
    return () => {
      if (unmount) unmount()
    }
  }, [])
}
